import { message } from 'antd';

const ERROR_KEY = 'app-error';
const SUCCESS_KEY = 'app-success';

export const showError = (content: string | undefined | null, duration = 4) => {
  if (!content) return;
  message.open({ key: ERROR_KEY, type: 'error', content, duration });
};

export const showSuccess = (content: string | undefined | null, duration = 3) => {
  if (!content) return;
  message.open({ key: SUCCESS_KEY, type: 'success', content, duration });
};
